import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Form } from "antd";

import {
    usersSetModeGeneralModal,
    usersSetSelectedGeneralPartner,
    usersSetShowGeneralModal,
} from '../../../../store/actions/usersActions';

import AccountModal from "../../../../commons/components/AccountModal"
import Loading from "../../../../commons/components/loading";
import RolesSelect from "../../../../commons/components/RolesSelect";

import generalModalModes from './generalModalModes'
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";
import Permissions from "../../../../commons/utils/permissions";

function GeneralModal({ onSave }) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { showGeneralModal, modeGeneralModal, selectedUser, selectedGeneralPartner } = useSelector((state) => state.users);
    const [permissions] = useState([]);
    const [loading, setLoading] = useState(false);

    const applicationExperienceId = 6;

    const [roleTreeData, setRoleTreeData] = useState([]);
    const [roleTreeExpandedItems, setRoleTreeExpandedItems] = useState([]);
    const [roleTreeSelectedItems, setRoleTreeSelectedItems] = useState([]);
    const [errorRoleSelect, setErrorRoleSelect] = useState("");

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });

            getRoleTreeData();
        }
    }, [screens]);

    useEffect(() => {
        if (selectedGeneralPartner.id && modeGeneralModal != generalModalModes.INSERT) {
            getRolesChecked(selectedGeneralPartner.applications);
        }
    }, [selectedGeneralPartner]);

    function getRolesChecked(applications) {
        let array = [];
        applications.forEach((application) => {
            application.roles.forEach((role) => {
                array.push(application.id + '-' + role.id)
            });
        });

        setRoleTreeSelectedItems(array);
    }

    function getRoleTreeData() {
        setLoading(true);

        const enableOnlyExperience = permissions.find(_function => _function.function_id === Permissions.LISTAR_ROLES_EXPERIENCE);
        const enableCompleteRoles = permissions.find(_function => _function.function_id === Permissions.LISTAR_ROLES_COMPLETO);

        Http.get(`/roles/roles-and-applications`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {

                    let applicationRoles = [];
                    responseData.data.map((dataItem) => {
                        if (dataItem.partner_scoped == false) {
                            let application = {
                                title: dataItem.name,
                                key: dataItem.id,
                                id: dataItem.id,
                                disabled: (enableOnlyExperience && dataItem.id !== applicationExperienceId) && !enableCompleteRoles,
                            };
                            let roles = [];
                            dataItem.roles.map((dataRole) => {
                                let role = {
                                    title: dataRole.name,
                                    key: dataItem.id + '-' + dataRole.id,
                                    id: dataRole.id,
                                    disabled: (enableOnlyExperience && dataItem.id !== applicationExperienceId) && !enableCompleteRoles,
                                }
                                roles.push(role);
                            })
                            application.children = roles;
                            applicationRoles.push(application);
                        }
                    })

                    setRoleTreeData(applicationRoles)
                    setLoading(false);
                }
            }).catch(err => {
                setRoleTreeData([]);
                setLoading(false);
            })
    }

    async function insertGeneralPermissions(body) {
        try {
            let response = await Http.post(`/users`, body, Http.headers);
            return response
        } catch (error) {
            if (error.response) {
                Message.showError(error.response.data.response.message);
            }
            else {
                Message.showError("Erro ao atualizar permissões gerais");
            }
        }
    }

    function validateForm() {
        let valid = true;

        if (roleTreeSelectedItems.length == 0) {
            setErrorRoleSelect("Informe uma role");
            valid = false;
        }

        return valid;
    }

    function renderButtons() {
        if (modeGeneralModal == generalModalModes.VIEW) {
            return (
                <button key="cancel" onClick={handleClear} className="ant-btn ant-btn-primary">Ok</button>
            )
        } else {
            return (
                <>
                    <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                    <button key="confirm" onClick={handleSave} className="ant-btn ant-btn-primary">Salvar</button>
                </>
            )
        }
    }

    async function handleSave() {
        if (validateForm()) {

            let body = {
                "email": selectedUser.email,
            };

            let bodyRoles = [];
            roleTreeData.map((application) => {
                application.children.map((role) => {
                    if (roleTreeSelectedItems.includes(role.key)) {
                        bodyRoles.push({
                            "partner_id": selectedGeneralPartner.id,
                            "application_id": application.id,
                            "role_id": role.id,
                        })
                    }
                })
            })
            body.roles = bodyRoles;

            if (selectedGeneralPartner.id && modeGeneralModal == generalModalModes.EDIT) {
                body.isAccountWeb = true;
            }

            setLoading(true);
            const responseInsert = await insertGeneralPermissions(body);
            if (responseInsert && !responseInsert.data.response.error) {
                Message.showSuccess(responseInsert.data.response.message);
                onSave();
                handleClear();
            }
            setLoading(false);
        }
    }

    function handleClear() {
        dispatch(usersSetShowGeneralModal(false));
        dispatch(usersSetModeGeneralModal(null));
        dispatch(usersSetSelectedGeneralPartner({}));

        setRoleTreeSelectedItems([]);
        setErrorRoleSelect("");

        setRoleTreeExpandedItems([]);

        setLoading(false);
    }

    function onRoleCheck(checkedKeys) {
        setRoleTreeSelectedItems(checkedKeys);
        setErrorRoleSelect("");
    };

    function renderForm() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <Form>
                    <Form.Item>
                        <RolesSelect
                            checkable={true}
                            onCheck={onRoleCheck}
                            checkedKeys={roleTreeSelectedItems}
                            expandedKeys={roleTreeExpandedItems}
                            treeData={roleTreeData}
                            error={errorRoleSelect}
                            onExpand={(items) => setRoleTreeExpandedItems(items)}
                        />
                    </Form.Item>
                </Form>
            )
        }
    }

    return (
        <AccountModal
            visible={showGeneralModal}
            title={"Permissões gerais"}
            onCancel={handleClear}
            footer={renderButtons()}>
            {renderForm()}
        </AccountModal>
    )
}

export default GeneralModal;

